import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar.js';
//import Create_loanrequests from './create_newaccounts';
import moment from 'moment/moment';


import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';



function Employee_daysummary(){


  //const imgpath = 'http://127.0.0.1:8000/storage/';
  //const imgpath = 'https://pragatiprathmik.com/api/';
  const imgpath = 'https://api.pragatiprathmik.com/storage/';

  
  
    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");
 const editId=sessionStorage.getItem("EditId00");
 const branch_id=sessionStorage.getItem("branchId00");

 
 //SETTING DATA VARIABLES
 const[date,setdate]=useState();
 const[day,setday]=useState();
 const[opening_balance,setopening_balance]=useState();
 const[loan_disbursals_count,setloan_disbursals_count]=useState();
  const[loan_disbursals_amount,setloan_disbursals_amount]=useState();
  const[new_customers_count,setnew_customers_count]=useState();
  const[partpayment_count,setpartpayment_count]=useState();
  const[partpayment_amount,setpartpayment_amount]=useState();
  const[loanclosure_count,setloanclosure_count]=useState();
  const[loanclosure_amount,setloanclosure_amount]=useState();
  const[emi_count,setemi_count]=useState();
  const[emi_amount,setemi_amount]=useState();
  const[pf_collection_count,setpf_collection_count]=useState();
  const[pf_collection_amount,setpf_collection_amount]=useState();
  const[insurance_collection_count,setinsurance_collection_count]=useState();
  const[insurance_collection_amount,setinsurance_collection_amount]=useState();
  const[opening_cash_balance,setopening_cash_balance]=useState();
  const[closing_cash_balance,setclosing_cash_balance]=useState();
  const[cash_inflow,setcash_inflow]=useState();
  const[cash_outflow,setcash_outflow]=useState();
  const[cash_closing_balance,setcash_closing_balance]=useState();
  const[opening_bank_balance,setopening_bank_balance]=useState();
  const[closing_bank_balance,setclosing_bank_balance]=useState();
  const[bank_inflow,setbank_inflow]=useState();
  const[bank_outflow,setbank_outflow]=useState();
  const[bank_closing_balance,setbank_closing_balance]=useState();
  const[closing_balance,setclosing_balance]=useState();
  const[c2000_in,setc2000_in]=useState();
  const[c500_in,setc500_in]=useState();
  const[c200_in,setc200_in]=useState();
  const[c100_in,setc100_in]=useState();
  const[c50_in,setc50_in]=useState();
  const[c20_in,setc20_in]=useState();
  const[c10_in,setc10_in]=useState();
  const[c5_in,setc5_in]=useState();
  const[c2_in,setc2_in]=useState();
  const[c1_in,setc1_in]=useState();
  const[c2000_out,setc2000_out]=useState();
  const[c500_out,setc500_out]=useState();
  const[c200_out,setc200_out]=useState();
  const[c100_out,setc100_out]=useState();
  const[c50_out,setc50_out]=useState();
  const[c20_out,setc20_out]=useState();
  const[c10_out,setc10_out]=useState();
  const[c5_out,setc5_out]=useState();
  const[c2_out,setc2_out]=useState();
  const[c1_out,setc1_out]=useState();
  const[summary_status,setsummary_status]=useState();
  const[status,setstatus]=useState();
  const[date_created,setdate_created]=useState();
  const[date_updated,setdate_updated]=useState();
  const[time_created,settime_created]=useState();
  const[time_updated,settime_updated]=useState();


//Header
const[haddress,sethaddress]=useState(sessionStorage.getItem("headerAddress00"));const updatehaddress = (event) => { sethaddress(event.target.value);}; const[haddress_er,sethaddress_er]=useState();
const[hcity,sethcity]=useState(sessionStorage.getItem("headerCity00"));const updatehcity = (event) => { sethcity(event.target.value);}; const[hcity_er,sethcity_er]=useState();
const[hstate,sethstate]=useState(sessionStorage.getItem("headerState00"));const updatehstate = (event) => { sethstate(event.target.value);}; const[hstate_er,sethstate_er]=useState();
const[hpincode,sethpincode]=useState(sessionStorage.getItem("headerPincode00"));const updatehpincode = (event) => { sethpincode(event.target.value);}; const[hpincode_er,sethpincode_er]=useState();
const[hemail,sethemail]=useState(sessionStorage.getItem("headerEmail00"));const updatehemail = (event) => { sethemail(event.target.value);}; const[hemail_er,sethemail_er]=useState();
const[hcontact,sethcontact]=useState(sessionStorage.getItem("headerContact00"));const updatehcontact = (event) => { sethcontact(event.target.value);}; const[hcontact_er,sethcontact_er]=useState();


  //ERROR VARIABLES 
  const[error_msg,seterror_msg]=useState();


 useEffect(()=>{
   
  getData();
  
  },[])
 

//******************* VIEW LOAN PART PAYMENT FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(branch_id>0)){


 axios.post("crm-employee_day_summary_default_load", {
   Log_id:logid,
   Token:token,
   Edit_id:editId,
   Branch_id:branch_id,
  
   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");
     sessionStorage.removeItem("EditId00");
     window.location.replace("/");
  }

  //Data Not Found
  if((response.data.error)==103){  seterror_msg(response.data.error_msg);}

  //Success Data Fetched
  if(response.data.successvar==1){

    //console.log(response.data);
   //Setting Data

   //OVERALL DATA
    setdate(response.data.date);
    setday(response.data.day);
    setopening_balance(response.data.opening_balance);
    setloan_disbursals_count(response.data.loan_disbursals_count);
    setloan_disbursals_amount(response.data.loan_disbursals_amount);
    setnew_customers_count(response.data.new_customers_count);
    setpartpayment_count(response.data.partpayment_count);
    setpartpayment_amount(response.data.partpayment_amount);
    setloanclosure_count(response.data.loanclosure_count);
    setloanclosure_amount(response.data.loanclosure_amount);
    setemi_count(response.data.emi_count);
    setemi_amount(response.data.emi_amount);
    setpf_collection_count(response.data.pf_collection_count);
    setpf_collection_amount(response.data.pf_collection_amount);
    setinsurance_collection_count(response.data.insurance_collection_count);
    setinsurance_collection_amount(response.data.insurance_collection_amount);
    setopening_cash_balance(response.data.cash_opening_balance);
    setclosing_cash_balance(response.data.closing_cash_balance);
    setcash_inflow(response.data.cash_inflow);
    setcash_outflow(response.data.cash_outflow);
    setcash_closing_balance(response.data.cash_closing_balance);
    setopening_bank_balance(response.data.bank_opening_balance);
    setclosing_bank_balance(response.data.closing_bank_balance);
    setbank_inflow(response.data.bank_inflow);
    setbank_outflow(response.data.bank_outflow);
    setbank_closing_balance(response.data.bank_closing_balance);
    setclosing_balance(response.data.closing_balance);
    setc2000_in(response.data.c2000_in);
    setc500_in(response.data.c500_in);
    setc200_in(response.data.c200_in);
    setc100_in(response.data.c100_in);
    setc50_in(response.data.c50_in);
    setc20_in(response.data.c20_in);
    setc10_in(response.data.c10_in);
    setc5_in(response.data.c5_in);
    setc2_in(response.data.c2_in);
    setc1_in(response.data.c1_in);
    setc2000_out(response.data.c2000_out);
    setc500_out(response.data.c500_out);
    setc200_out(response.data.c200_out);
    setc100_out(response.data.c100_out);
    setc50_out(response.data.c50_out);
    setc20_out(response.data.c20_out);
    setc10_out(response.data.c10_out);
    setc5_out(response.data.c5_out);
    setc2_out(response.data.c2_out);
    setc1_out(response.data.c1_out);
    setsummary_status(response.data.summary_status);
    setstatus(response.data.status);
    setdate_created(response.data.date_created);
    setdate_updated(response.data.date_updated);
    settime_created(response.data.time_created);
    settime_updated(response.data.time_updated);



  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){ seterror_msg("Validation error!"); }

  //Data Violation
  if(response.data.error==102){  seterror_msg("Violation Error"); }

 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");
   sessionStorage.removeItem("EditId00");
   window.location.replace("/"); 
   //console.log(response.data);
 
  }
 
 }
  
 //******************* VIEW LOAN PART PAYMENT FUNCTION END  ********************//



 
return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Admin Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

   {/*}   <Sidebar /> */}
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

           

          <div className="page-header flex-wrap">
          <div className="header-left">
           <button style={{marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-outline-info" onClick={()=>{ window.location.replace("/employee-dashboard-daysummarylist")}}>  Back </button>
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">DAY SUMMARY</p>
                  </a>
                </div>
               <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>{
                    sessionStorage.setItem("EditId00", editId);
                    sessionStorage.setItem("CAmount00", cash_closing_balance);
                    sessionStorage.setItem("CDate00", date);
                    window.location.replace("/employee-dashboard-manage-daycash");
               }}>
                  <i className="mdi mdi-plus-circle"></i> Manage Day Cash </button>
              </div>
            </div>

            <button type="button" style={{backgroundColor:"#196fb0", marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <br/><br/>



                <div class="card">

                  {/* Print Section Start */}
                  <div class="" style={{padding:"1rem"}}  id="invoice" ref={componentRef}>

                      {/* PART PAYMENT REQUEST HEADER START */}
                      <div class="offer-letter-head" style={{borderBottom:"0.2rem solid #038d8e"}}>
                  <div style={{flexDirection:"row", display:"flex"}}>
                  <div style={{width:"25%"}} >
                    <img src="images/crmlogo.png" alt="profile" style={{width:"16rem", height:"16rem"}} />
                  </div>
                  <div class="row" style={{width:"75%"}}>

                    <div class="row col-md-12">
                    <h1 style={{color:"#038d8e", marginBottom:"0", textAlign:"center"}}><b>Pragati Prathmik Sakh Sahkari Samiti Maryadit</b></h1>
                    
                    <p style={{marginTop:"0", textAlign:"center"}}><b>Address:</b> {haddress} <br/>
                    {hcity} ({hstate}), ({hpincode}) <br/><br/>
                    <b>Email:</b> {hemail}, <b>Contact:</b> {hcontact}</p>

                  
                    </div>
                    </div>
                    </div>
                    </div>
                    
                    {/* PART PAYMENT REQUEST HEADER END */}
                    
                      <h2 style={{textAlign:"center", marginTop:"2rem"}}>SUMMARY</h2>
                      <hr/>
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h3 class="card-title">SUMMARY</h3>
                    <div class="form-sample" style={{textAlign:"left"}}>

                    <div class="row" style={{textAlign:"left"}}>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Date:</b></p></div>
                    <div class="row col-sm-6"> <p>{date}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Day:</b></p></div>
                    <div class="row col-sm-6"> <p>{day}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Opening balance:</b></p></div>
                    <div class="row col-sm-6"> <p>{opening_balance}</p></div>
                    </div>
                    <hr/>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Disbursals Count:</b></p></div>
                    <div class="row col-sm-6"> <p>{loan_disbursals_count}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Disbursals Amount:</b></p></div>
                    <div class="row col-sm-6"> <p>{loan_disbursals_amount}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>New Customers:</b></p></div>
                    <div class="row col-sm-6"> <p>{new_customers_count}</p></div>
                    </div>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Loan Closure Count:</b></p></div>
                    <div class="row col-sm-6"> <p>{loanclosure_count}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Part Payment Count:</b></p></div>
                    <div class="row col-sm-6"> <p>{partpayment_count}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Collected EMIs Count:</b></p></div>
                    <div class="row col-sm-6"> <p>{emi_count}</p></div>
                    </div>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Loan Closure Amount:</b></p></div>
                    <div class="row col-sm-6"> <p>{loanclosure_amount}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Part Payment Amount:</b></p></div>
                    <div class="row col-sm-6"> <p>{partpayment_amount}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Collected EMIs Amount:</b></p></div>
                    <div class="row col-sm-6"> <p>{emi_amount}</p></div>
                    </div>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Insurance Collected(with gst):</b></p></div>
                    <div class="row col-sm-6"> <p>{insurance_collection_amount}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>PF Collected:</b></p></div>
                    <div class="row col-sm-6"> <p>{pf_collection_amount}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Updated:</b></p></div>
                    <div class="row col-sm-6"> <p>{date_updated} ({time_updated})</p></div>
                    </div>
                    <hr/>

                    <h3 class="card-title">CASH FLOW</h3>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Opening Cash Balance:</b></p></div>
                    <div class="row col-sm-6"> <p><b>{opening_cash_balance}</b></p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Opening Bank Balance:</b></p></div>
                    <div class="row col-sm-6"> <p>{opening_bank_balance}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Opening Balance:</b></p></div>
                    <div class="row col-sm-6"> <p><b>{opening_balance}</b></p></div>
                    </div>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Cash Inflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-success"><b>{cash_inflow}</b></p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Bank Inflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-success">{bank_inflow}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Total Inflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-success"><b>{parseFloat(cash_inflow)+parseFloat(bank_inflow)}</b></p></div>
                    </div>

                    
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Cash Outflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-danger"><b>{cash_outflow}</b></p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Bank Outflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-danger">{bank_outflow}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Total Outflow:</b></p></div>
                    <div class="row col-sm-6"> <p class="text-danger"><b>{parseFloat(cash_outflow)+parseFloat(bank_outflow)}</b></p></div>
                    </div>

                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Closing Cash Balance:</b></p></div>
                    <div class="row col-sm-6"> <p><b>{cash_closing_balance}</b></p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Closing Bank Balance:</b></p></div>
                    <div class="row col-sm-6"> <p>{bank_closing_balance}</p></div>
                    </div>
                    <div class="row col-md-4">
                    <div class="row col-sm-6"> <p><b>Closing Balance:</b></p></div>
                    <div class="row col-sm-6"> <p><b>{closing_balance}</b></p></div>
                    </div>



                 

                    </div>
                    </div>
                    <hr/>

                
              </div>
             
                    <hr/>
                    <h3 class="card-title">CURRENCY SUMMARY</h3>
                    <div class="form-sample" style={{textAlign:"left"}}>

                   <div class="row" style={{textAlign:"left"}}>
                   <div class="table-responsive">
                    <table class="table table-bordered">
                    <thead>
                       <tr>
                      <td><b>Currency</b></td>
                      <td><b>2000</b></td>
                      <td><b>500</b></td>
                      <td><b>200</b></td>
                      <td><b>100</b></td>
                      <td><b>50</b></td>
                      <td><b>20</b></td>
                      <td><b>10</b></td>
                      <td><b>5</b></td>
                      <td><b>2</b></td>
                      <td><b>1</b></td>
                      <td><b>Total</b></td>
                     </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><b>In</b></td>
                        <td>{c2000_in}</td>
                        <td>{c500_in}</td>
                        <td>{c200_in}</td>
                        <td>{c100_in}</td>
                        <td>{c50_in}</td>
                        <td>{c20_in}</td>
                        <td>{c10_in}</td>
                        <td>{c5_in}</td>
                        <td>{c2_in}</td>
                        <td>{c1_in}</td>
                        <td>{parseFloat(c2000_in)+parseFloat(c500_in)+parseFloat(c200_in)+parseFloat(c100_in)+parseFloat(c50_in)+parseFloat(c20_in)+parseFloat(c10_in)+parseFloat(c5_in)+parseFloat(c2_in)+parseFloat(c1_in)}</td>
                      </tr>
                      <tr>
                        <td><b>Out</b></td>
                        <td>{c2000_out}</td>
                        <td>{c500_out}</td>
                        <td>{c200_out}</td>
                        <td>{c100_out}</td>
                        <td>{c50_out}</td>
                        <td>{c20_out}</td>
                        <td>{c10_out}</td>
                        <td>{c5_out}</td>
                        <td>{c2_out}</td>
                        <td>{c1_out}</td>
                        <td>{parseFloat(c2000_out)+parseFloat(c500_out)+parseFloat(c200_out)+parseFloat(c100_out)+parseFloat(c50_out)+parseFloat(c20_out)+parseFloat(c10_out)+parseFloat(c5_out)+parseFloat(c2_out)+parseFloat(c1_out)}</td>
                      </tr>
                      <tr>
                        <td><b>Balance</b></td>
                        <td>{parseFloat(c2000_in)-parseFloat(c2000_out)}</td>
                        <td>{parseFloat(c500_in)-parseFloat(c500_out)}</td>
                        <td>{parseFloat(c200_in)-parseFloat(c200_out)}</td>
                        <td>{parseFloat(c100_in)-parseFloat(c100_out)}</td>
                        <td>{parseFloat(c50_in)-parseFloat(c50_out)}</td>
                        <td>{parseFloat(c20_in)-parseFloat(c20_out)}</td>
                        <td>{parseFloat(c10_in)-parseFloat(c10_out)}</td>
                        <td>{parseFloat(c5_in)-parseFloat(c5_out)}</td>
                        <td>{parseFloat(c2_in)-parseFloat(c2_out)}</td>
                        <td>{parseFloat(c1_in)-parseFloat(c1_out)}</td>
                        <td>{parseFloat(parseFloat(c2000_in)-parseFloat(c2000_out))+parseFloat(parseFloat(c500_in)-parseFloat(c500_out))+parseFloat(parseFloat(c200_in)-parseFloat(c200_out))+parseFloat(parseFloat(c100_in)-parseFloat(c100_out))+parseFloat(parseFloat(c50_in)
                        -parseFloat(c50_out))+parseFloat(parseFloat(c20_in)-parseFloat(c20_out))+parseFloat(parseFloat(c10_in)-parseFloat(c10_out))+parseFloat(parseFloat(c5_in)-parseFloat(c5_out))+parseFloat(parseFloat(c2_in)-parseFloat(c2_out))+parseFloat(parseFloat(c1_in)-parseFloat(c1_out))}</td>
                      </tr>
                        <tr>
                        <td><b>Sum</b></td>
                        <td>{2000*(parseFloat(c2000_in)-parseFloat(c2000_out))}</td>
                        <td>{500*(parseFloat(c500_in)-parseFloat(c500_out))}</td>
                        <td>{200*(parseFloat(c200_in)-parseFloat(c200_out))}</td>
                        <td>{100*(parseFloat(c100_in)-parseFloat(c100_out))}</td>
                        <td>{50*(parseFloat(c50_in)-parseFloat(c50_out))}</td>
                        <td>{20*(parseFloat(c20_in)-parseFloat(c20_out))}</td>
                        <td>{10*(parseFloat(c10_in)-parseFloat(c10_out))}</td>
                        <td>{5*(parseFloat(c5_in)-parseFloat(c5_out))}</td>
                        <td>{2*(parseFloat(c2_in)-parseFloat(c2_out))}</td>
                        <td>{1*(parseFloat(c1_in)-parseFloat(c1_out))}</td>
                        <td>{parseFloat(2000*(parseFloat(c2000_in)-parseFloat(c2000_out)))+parseFloat(500*(parseFloat(c500_in)-parseFloat(c500_out)))+parseFloat(200*(parseFloat(c200_in)-parseFloat(c200_out)))
                        +parseFloat(100*(parseFloat(c100_in)-parseFloat(c100_out)))+parseFloat(50*(parseFloat(c50_in)-parseFloat(c50_out)))+parseFloat(20*(parseFloat(c20_in)-parseFloat(c20_out)))+
                        parseFloat(10*(parseFloat(c10_in)-parseFloat(c10_out)))+parseFloat(5*(parseFloat(c5_in)-parseFloat(c5_out)))+parseFloat(2*(parseFloat(c2_in)-parseFloat(c2_out)))+parseFloat(1*(parseFloat(c1_in)-parseFloat(c1_out)))}</td>
                        </tr>
  
                    </tbody>
                    </table>
                   </div>
                   </div>
                   </div> 
                   
                    
                    
                     <hr/>
                   {/*} <br/><br/><br/>
                    <div class="row col-md-12 d-print-flex">
                    <div class="row col-sm-4 col d-print-inline-block text-center"> <p><b>Customer Signature</b></p></div>
                    <div class="row col-sm-4 col d-print-inline-block text-center"> <p><b>Loan Officer Signature</b></p></div>
                    <div class="row col-sm-4 col d-print-inline-block text-center"> <p><b>Branch Seal & Signature</b></p></div>
                    </div> */}
                   <br/><br/>
                    </div>
                    </div>
                    

                
              
                 
              
                

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Employee_daysummary;